import { useEffect, useState } from "react";
import { CreateRenovacionCartaFianza } from "../../../../api/Api";
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader";
import { useGetUser } from "../../../../Hooks/CustomHooks";

export default function GenerateRenovacionModal({
    showModal = false,
    setShowModal,
    value,
    onFinishService
}) {

    const [isLoandingGenerateRequerimiento, setIsLoandingGenerateRequerimiento] = useState(false);
    const [isFinishGenerateRequerimiento, setIsFinishGenerateRequerimiento] = useState(false);
    const [isModalTitleGenerateRequerimiento, setIsModalTitleGenerateRequerimiento] = useState("");

    const user = useGetUser();

    const TITLE_STATE = {
        BEFORE_SERVICE: "Generar Renovacion",
        DURING_SERVICE: "Generando Renovación",
        AFTER_SERVICE: "Renovación generada"
    }

    const onConfirmGenerateRequerimiento = () => {
        setIsLoandingGenerateRequerimiento(true)
        setIsModalTitleGenerateRequerimiento(TITLE_STATE.DURING_SERVICE);
        CreateRenovacionCartaFianza(value.data.detalle_garantia.id_garantia_detalle, user.email).then((response) => {
            setIsModalTitleGenerateRequerimiento(TITLE_STATE.AFTER_SERVICE);
            setIsLoandingGenerateRequerimiento(false);
            setIsFinishGenerateRequerimiento(true);
            onFinishService && onFinishService();
        });
    }

    useEffect(() => {
        if (showModal) {
            setIsFinishGenerateRequerimiento(false);
            setIsModalTitleGenerateRequerimiento(TITLE_STATE.BEFORE_SERVICE);
        }
    }, [showModal, TITLE_STATE.BEFORE_SERVICE]);

    return (
        <ConfirmWithLoader
            showModal={showModal}
            setShowModal={setShowModal}
            onConfirm={onConfirmGenerateRequerimiento}
            title={isModalTitleGenerateRequerimiento}
            isLoading={isLoandingGenerateRequerimiento}
            isFinish={isFinishGenerateRequerimiento}
            textButton={"Generar"}
        >
            {!isLoandingGenerateRequerimiento && isFinishGenerateRequerimiento ? (
                <div>Se genero la Renovación de Carta Fianza </div>
            ) : (
                <div>Seguro de Generar la Renovación de Carta Fianza</div>
            )}
        </ConfirmWithLoader>
    )
}